import $ from "jquery";

const historyService = {
    getState() {
        return window.history.state || {};
    },
    replaceState(dataObject, url) {
        window.history.replaceState(dataObject, document.title, url);
    },
    pushState(dataObject, url) {
        window.history.pushState(dataObject, document.title, url);
    },
    supportedSR() {
        // https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
        return 'scrollRestoration' in history;
    },
    restorePos(position) {
        if (this.supportedSR()) {
            window.history.scrollRestoration = 'manual';
        }
        $(window).scrollTop(position);
    }
};

export default historyService;
